<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Applications</p>
          </div>
        </div>
      </div>
      Total Records : <b>{{ total }}</b>
      <card-component>
        <form @submit.prevent="getApplication">
          <div class="columns">

            <div class="column is-3">
              <label class="label">Status</label>
              <div class="select is-fullwidth">
                <select v-model="filter.status">
                  <option value="NotYetAdmitted">Not Yet Admitted</option>
                  <option value="Admitted">Admitted</option>
                  <option value="All">All</option>
                </select>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">From </label>
              <div class="control">
                <input class="input" type="date" v-model="filter.fromDate" :max="filter.ToDate" />
              </div>
            </div>

            <div class="column is-3">
              <label class="label">To </label>
              <div class="control">
                <input class="input" type="date" v-model="filter.toDate" :max="filter.ToDate"/>
              </div>
            </div>

          <div class="column is-3">
            <label class="label">Action</label>
            <button class="button is-primary m-r-10" type="submit">Apply</button>
          </div>
</div>
        </form>
      </card-component>
    </section>

    <section class="section is-main-section">
      <card-component title="" class="has-table">
        <b-table :paginated="true" :per-page="10" :striped="true" :hoverable="true" detailed :data="ApplicationData">
          <template slot-scope="props">
            <b-table-column label="SrNo." field="SrNo." sortable>
              {{ props.index + 1 }}
            </b-table-column>

            <b-table-column label="Name" field="studentName" sortable>
              {{ props.row.studentName }}
            </b-table-column>

            <b-table-column label="Application Form Number" field="applicationCode" sortable>
              {{ props.row.applicationCode || '' }}
            </b-table-column>

            <b-table-column label="Class" field="studentClass.name" sortable>
              {{ props.row.studentClass ? props.row.studentClass.name : '' }}
            </b-table-column>

            <b-table-column label="Admission Status" field="status" sortable centered>
              <b class="has-text-link is-capitalized">
                {{ props.row.status || '-' }}
              </b>
            </b-table-column>

            <b-table-column label="Application Date" field="Date" sortable width="120">
              {{ props.row.dateOfApplication || '-' }}
            </b-table-column>

            <b-table-column label="Enquiry Created Date" field="Date" sortable width="120">
              {{ props.row.createdAt }}
            </b-table-column>

            <b-table-column label="Amount Paid" field="amount" width="100" sortable>
              <span class="mdi mdi-currency-inr"></span>
              {{ props.row.amount || '0' }}
            </b-table-column>

            <b-table-column label="Action" custom-key="Action" class="is-actions-cell" centered width="140">
              <div class="buttons" v-if="props.row.status !=='Admitted'">
                <button
                  class="button is-small is-danger"
                  type="button"
                  @click.prevent="sendRegistrationFormLinkToParent(props.row.id)"
                  title="Send Registration form link to Parent"
                >
                  <b-icon icon="email" size="is-small" />
                </button>
              </div>
<div v-else>-</div>
            </b-table-column>
          </template>
          <template slot="detail" slot-scope="props">
            <div class="columns">
              <div class="column is-4">
                <p><b>Parent Name:</b> {{ props.row.fatherName }}</p>
                <p><b>Source of Enquiry:</b> {{ props.row.source ? props.row.source.name : '-' }}</p>
              </div>
              <div class="column is-4">
                <p><b>Contact Number:</b> {{ props.row.fatherMobile }}</p>
                <p><b>Remark:</b> {{ props.row.Remarks || '-' }}</p>
              </div>
              <div class="column is-4"><b>Email:</b> {{ props.row.fatherEmailID }}</div>
            </div>
          </template>
          <section class="section" slot="empty">
            <div class="content has-text-grey has-text-centered">
              <template v-if="isLoading">
                <p>
                  <b-icon icon="dots-horizontal" size="is-large" />
                </p>
                <p>Fetching data...</p>
              </template>
              <template v-else>
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>Nothing's here&hellip;</p>
              </template>
            </div>
          </section>
        </b-table>
      </card-component>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'Applications',
  components: {
    CardComponent
  },
  data () {
    return {
      total: 0,
      isLoading: false,
      loadingComponent: null,
      enableFilterModal: false,
      enableSearchModal: false,
      ApplicationData: [],
      franchiseeID: '',
      filter: {
        dateRange: '30',
        academicYearID: '',
        sourceID: 'All',
        status: 'All',
        fromDate: new Date().toISOString().slice(0, 10),
        toDate: new Date().toISOString().slice(0, 10)
      },
      academicYears: [],
      academicYearID: '',
      sources: [],
      maxToDate: new Date().toISOString().slice(0, 10)
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },

  async created () {
    try {
      const fromDate = new Date(new Date().setMonth(new Date().getMonth() - 1))
      this.filter.FromDate = fromDate.toISOString().slice(0, 10)
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.sources = questions.filter(obj => obj.type === 'SOURCE_OF_CONTACT')
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
      this.getApplication()
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.getApplication()

        this.inProgress = false
      }
    },
    getApplication: async function () {
      try {
        if ((this.academicYear) && (this.franchisee.id)) {
          const { data } = await http.post(`${constants.API_URL}/api/enquiry/application`, {
            franchiseeID: this.franchisee.id,
            academicYearID: this.academicYear ? this.academicYear.id : this.academicYearID,
            fromDate: this.filter.fromDate,
            toDate: this.filter.toDate,
            status: this.filter.status
          })

          this.ApplicationData = data
          this.total = this.ApplicationData.length
          this.ApplicationData.forEach(Enq => {
            Enq.createdAt = moment(Enq.createdAt).format('D MMM YYYY')
            Enq.dateOfApplication = Enq.dateOfApplication ? moment(Enq.dateOfApplication).format('D MMM YYYY') : null
            Enq.studentName = Enq.studentFirstName
            if (Enq.studentMiddleName) {
              Enq.studentName = Enq.studentName + ' ' + Enq.studentMiddleName
            }
            if (Enq.studentLastName) {
              Enq.studentName = Enq.studentName + ' ' + Enq.studentLastName
            }
            if (Enq.enrollmentCode) {
              Enq.status = 'Admitted'
            }
            if (!Enq.enrollmentCode) {
              Enq.status = 'Not Yet Admitted'
            }
          })
          this.enableFilterModal = false
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    sendRegistrationFormLinkToParent: async function (enqID) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.lock = true

        const formData = {
          enquiryID: enqID
        }

        /** * generate Application link */
        await http.post(`${constants.API_URL}/api/generateRegistrationFormLink`, formData)

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Email is sent to parent for filling further details !',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    searchEnquiry: function () {
      this.$router.push({ name: 'applicationForm' })
    },
    toggleFilterModal: function () {
      this.enableFilterModal = !this.enableFilterModal
    },
    toggleSearchModal: function () {
      this.enableSearchModal = !this.enableSearchModal
    },
    placeOrder: function (enquiryObj) {
      this.$buefy.dialog.confirm({
        title: 'Confirm Order',
        message: 'Are you sure you want to place this order?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            await http.post(`${constants.API_URL}/api/order/gift-box/enquiry`, {
              franchiseeID: enquiryObj.franchiseeID,
              studentID: enquiryObj.id
            })
            await this.getApplication()
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    }
  }
}
</script>
